import React, { useEffect, useMemo } from "react";
import { Global_Data } from "../../globalData/GlobalData";
import {
    getVarStoreReferences,
    resolveVarStoreExpression
} from "./varStoreExpression";

const RenderVarstore = ({ freeFormTabbleEditMainrecord, data }) => {

    const {
        modalEditData,
        setTextValue,
        textValue
    } = Global_Data?.() || {};
    const expression = data?.component?.sValue;
    const referencedFields = useMemo(
        () => getVarStoreReferences(expression),
        [expression]
    );
    const referencedValues = referencedFields.map(fieldName =>
        textValue?.[fieldName] ??
        freeFormTabbleEditMainrecord?.[fieldName] ??
        modalEditData?.[fieldName] ??
        ""
    );
    const resolvedSetValue = resolveVarStoreExpression(
        expression,
        referencedFields.reduce((values, fieldName, index) => ({
            ...values,
            [fieldName]: referencedValues[index]
        }), {})
    );

    useEffect(() => {
        if (data?.component?.sMode === "SET") {
            if (data?.component?.sName) {
                localStorage.setItem(data.component.sName, resolvedSetValue);
                setTextValue(prev =>
                    prev?.[data.component.sName] === resolvedSetValue
                        ? prev
                        : {...prev, [data.component.sName]: resolvedSetValue}
                );
            }
        } else if(data?.component?.sMode === "GET") {
            if (data?.component?.sName) {
                const value = localStorage.getItem(data.component.sName);
                setTextValue(prev =>
                    prev?.[data.component.sName] === value
                        ? prev
                        : {...prev, [data.component.sName]: value}
                );
            }
        }
    }, [
        data?.component?.sMode,
        data?.component?.sName,
        resolvedSetValue,
        setTextValue
    ]);

    return <></>;
};

export default RenderVarstore;
